import yeongwol from '../assets/yeongwol.png';
import goheungSlogan from '../assets/goheung-slogan.png';
import seocheonPanorama from '../assets/seocheon-panorama.png';
import worldcuppark from '../assets/worldcuppark.png';
import worldcupstadium from '../assets/worldcupstadium.png';

// 썸네일은 16:9 비율(권장 1600 × 900)의 WebP 또는 JPG를 사용합니다.
// image와 href를 채우면 카드가 자동으로 클릭 가능한 프로젝트로 전환됩니다.
export const panoramaProjects = [
  {
    category: '고흥군',
    title: '고흥 파노라마',
    description: '고흥의 현장감을 생생하게 전달할 360° 파노라마 콘텐츠를 준비하고 있습니다.',
    image: null,
    href: null,
    placeholder: {
      variant: 'goheung',
      logo: goheungSlogan,
      label: 'COMING SOON',
    },
    isPending: true,
    actionLabel: '서비스 준비 중',
  },
  {
    category: '서천군',
    title: '서천군 하늘지도',
    description: '디지털서천문화대전에서 제공하는 서천군 360° 공간 콘텐츠입니다.',
    image: seocheonPanorama,
    href: 'https://seocheon.grandculture.net/Panorama/seocheon',
  },
  {
    category: '서울',
    title: 'Worldcup Stadium',
    description: '월드컵경기장을 파노라마로 둘러보는 공간 경험입니다.',
    image: worldcupstadium,
    href: 'http://worldcup.4smapper.com/',
  },
  {
    category: '서울',
    title: 'Worldcup Park',
    description: '월드컵공원의 주요 지점을 연결한 파노라마 프로젝트입니다.',
    image: worldcuppark,
    href: 'http://worldcuppark.4smapper.com/',
  },
  {
    category: '영월',
    title: '영월 비행 시험장',
    description: '영월 비행 시험장의 현장 환경을 온라인으로 살펴볼 수 있습니다.',
    image: yeongwol,
    href: 'http://yeongwol.dromii.com/',
  },
];
